import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=76934e7c&scoped=true&"
import script from "./Reset.vue?vue&type=script&lang=js&"
export * from "./Reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76934e7c",
  null
  
)

export default component.exports